module.exports = __webpack_public_path__ + "img/k2.06d72a29.jpg";